import React, { useState, useEffect, useRef } from "react";
import styles from "./DetailBar.module.less";
import Icon from "@/components/Icon/Icon";
import { useCartStore, useCorpInfoStore } from "@/stores";
import { useNavigate } from "react-router-dom";
import { routesMap, common } from "@/utils";
import { t } from '@/utils/i18n'

const {hasHomeModule} = common

interface DetailBarProps {
  onAddToCart?: () => void;
  showFlyCart: boolean;
  onCompleteFlyCart?: () => void;
}

const DetailBar: React.FC<DetailBarProps> = (props) => {
  const { corpInfo } = useCorpInfoStore();
  const { cart } = useCartStore();
  const navigate = useNavigate();
  const { onAddToCart } = props;
  // const { onAddToCart, showFlyCart, onCompleteFlyCart } = props
  const [cartNumber, setCartNumber] = useState(0);
  const cartBtn = useRef<HTMLButtonElement>(null);
  const cartTotal = useRef<HTMLDivElement>(null);
  // const [start, setStart] = useState<number[]>([])
  // const [end, setEnd] = useState<number[]>([])

  // useEffect(() => {
  //   if (cartBtn.current) {
  //     const ClientRect = cartBtn.current?.getBoundingClientRect()
  //     const x = ClientRect.x + ClientRect.width / 2
  //     const y = 60
  //     setStart([x, y])
  //   }

  //   if (cartTotal.current) {
  //     const ClientRect = cartTotal.current?.getBoundingClientRect()
  //     const x = ClientRect.x + ClientRect.width / 2
  //     const y = 60
  //     setEnd([x, y])
  //   }
  // }, [])

  useEffect(() => {
    setCartNumber(cart.productCount);
  }, [cart.productCount]);

  const getNumClassName = (number: number) => {
    let className = `${styles["bar-item-num"]} `; // 默认 className 'bar-item-num'
    if (number < 10) {
      className += `${styles.small}`;
    } else if (number > 1 && number < 100) {
      className += `${styles.normal}`;
    } else {
      className += `${styles.big}`;
    }
    return className;
  };

  // 跳转
  function handleGoto(path: string) {
    if (!corpInfo?.accountId && [routesMap.ShoppingCart, routesMap.MyCenter].indexOf(path) > -1) {
      // navigate(routesMap.Login);
      common.logout()
      return;
    }

    navigate(path);
  }

  // 回到首页
  async function handleEnterStore() {
    const homeModule = await hasHomeModule();
    if (homeModule) {
      navigate(routesMap.App)
    } else {
      navigate(routesMap.Products)
    }
  }

  return (
    <div className={styles["detail-bar"]}>
      <div className={styles["placeholder"]}></div>
      <div className={styles["detail-bar-bd"]}>
        <div className={styles["bar-item"]} onClick={handleEnterStore}>
          <Icon name={"home"} size={"44"} color={"#222222"} />
          <p>{t('首页')}</p>
        </div>
        <div
          className={styles["bar-item"]}
          ref={cartTotal}
          onClick={() => handleGoto(routesMap.ShoppingCart)}
        >
          <Icon name={"cart"} size={"44"} color={"#222222"} />
          <p>{t('购物车')}</p>
          {/* 图标右上角数字 */}
          {cartNumber > 0 ? (
            <div className={getNumClassName(cartNumber)}>
              {cartNumber >= 100 ? "99+" : cartNumber}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={styles["bar-item"] + " " + styles["btn-wrap"]}>
          <button ref={cartBtn} onClick={onAddToCart}>
            {t('购买')}
          </button>
        </div>
      </div>
      {/* <FlyCart show={showFlyCart} onComplete={onCompleteFlyCart} start={start} end={end} /> */}
    </div>
  );
};

export default DetailBar;
